import { Container, Row, Col } from 'react-bootstrap';
import { Route, Routes } from 'react-router';
import type { PublicDocument } from '../types/api.types';
import SubNavLink from '../common/sub-nav-link';
import CommitteeContainer from './committee-container';

import htmlObjective from './objective.html?raw';
import htmlConstitution from './constitution.html?raw';
import htmlOrganisation from './organisation.html?raw';
import htmlCompetitions from './competitions.html?raw';
import htmlFormats from './formats.html?raw';
import htmlHandicaps from './handicaps.html?raw';
import htmlPlaying from './playing-an-event.html?raw';

import './styles.css';

interface AboutPageProps {
  publicDocuments: PublicDocument[];
}

function HtmlContent({ html }: { html: string }) {
  return <div dangerouslySetInnerHTML={{ __html: html }} className="aboutpage" />;
}

function DocumentsList({ documents }: { documents: PublicDocument[] }) {
  return (
    <div className="aboutpage">
      {documents.map((doc) => (
        <div key={doc.id}>
          <a href={`https://drive.google.com/uc?id=${doc.id}&export=download`}>{doc.name}</a>
        </div>
      ))}
    </div>
  );
}

export default function AboutPage({ publicDocuments }: AboutPageProps) {
  return (
    <Container>
      <Row>
        <Col>
          <div className="sub-nav">
            <SubNavLink to="/about" label="Objective" end />
            <SubNavLink to="/about/committee" label="Committee" />
            <SubNavLink to="/about/constitution" label="Constitution" />
            <SubNavLink to="/about/organisation" label="Organisation" />
            <SubNavLink to="/about/competitions" label="Competitions" />
            <SubNavLink to="/about/formats" label="Formats" />
            <SubNavLink to="/about/handicaps" label="Handicaps" />
            <SubNavLink to="/about/playing" label="Playing an Event" />
            <SubNavLink to="/about/documents" label="Documents" />
          </div>

          <Routes>
            <Route index element={<HtmlContent html={htmlObjective} />} />
            <Route path="committee" element={<CommitteeContainer />} />
            <Route path="constitution" element={<HtmlContent html={htmlConstitution} />} />
            <Route path="organisation" element={<HtmlContent html={htmlOrganisation} />} />
            <Route path="competitions" element={<HtmlContent html={htmlCompetitions} />} />
            <Route path="formats" element={<HtmlContent html={htmlFormats} />} />
            <Route path="handicaps" element={<HtmlContent html={htmlHandicaps} />} />
            <Route path="playing" element={<HtmlContent html={htmlPlaying} />} />
            <Route path="documents" element={<DocumentsList documents={publicDocuments} />} />
          </Routes>
        </Col>
      </Row>
    </Container>
  );
}
